import React, { FunctionComponent } from 'react';

interface Props {
    children: any;
    menuOpen: boolean;
}

const FilterPageLeft: FunctionComponent<Props> = ({ children, menuOpen }) => {

    return (
        <div className={`filter-page__filter-container filter-page__filter-container--${menuOpen ? 'active' : 'closed'}`}>
            { children }
        </div>
    );
};

export default FilterPageLeft;
